export default {
    props: {
        rangeStart: {
            type: Date,
            default: undefined,
            kComposite: 'range.start'
        }, 
        rangeEnd: {
            type: Date,
            default: undefined,
            kComposite: 'range.end'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoDateRangePicker/Range.js